import { memo, useEffect, useState } from "react";
import { Button, Checkbox,  Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { mdlGiataRequest } from "../../models/ui-models/GiataRequest";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { InputHelper } from "../../utils/InputHelper";
import { toast } from "react-toastify";

export type FactSheetGiataProps = {
    data?: mdlGiataRequest;
    printMode?: boolean;
    fnModalClose?: Function;
    handlePrint?: Function,
}

export const FactSheetGiata = memo(function FactSheetGiata(props: FactSheetGiataProps) {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const [ip, setIp] = useState<string>('');
    useEffect(() => {
        if(props.data){
            form.setFieldValue("ipAddress",props.data?.ipAddress);
            form.setFieldValue("date",props.data?.date);
            form.setFieldValue("userName",props.data?.userName);
            form.setFieldValue("userTitle",props.data?.userTitle);
        }
    }, [props, ip]);

    const handlePrint = () =>  {
        const request = form.getFieldsValue(["userName","userTitle","ipAddress","date","readAndConfirm"]) as mdlGiataRequest;
        if(InputHelper.isNullOrUndefinedOrEmpty(request.readAndConfirm) || !request.readAndConfirm ){
            toast.error(t("factSheet.giataValidators.shouldBeConfirm"));
            return;
        }
        if(InputHelper.isNullOrUndefinedOrEmpty(request.userName)){
            toast.error(t("factSheet.giataValidators.userNameCannotBeEmpty"));
            return;
        }
        if(InputHelper.isNullOrUndefinedOrEmpty(request.userTitle)){
            toast.error(t("factSheet.giataValidators.userTitleCannotBeEmpty"));
            return;
        }
        props.handlePrint != undefined && 
        props.handlePrint(request);
        props.fnModalClose != undefined && props.fnModalClose();
    }

    return (
        <>
            <Form
                form={form}
                name="spo-form"
                layout="vertical"
                autoComplete="true"
            >
                <div className="row" style={{width: (props.printMode != undefined && props.printMode ? "1000px" : "auto")}}>
                    <div className="col-12">
                        <div dangerouslySetInnerHTML={{ __html: t("factSheet.giataSendDescription") }} />
                    </div>
                    <div className="col-12 my-4">
                        {
                            props.printMode != undefined && props.printMode 
                            ? <>
                                <Checkbox checked={props.data?.readAndConfirm}>
                                    {t("factSheet.readAndConfirm")}
                                </Checkbox>
                            </>
                            : <>
                                <Checkbox onChange={(e:CheckboxChangeEvent) => form.setFieldValue("readAndConfirm",e.target.checked)} >
                                    {t("factSheet.readAndConfirm")}
                                </Checkbox>
                            </>
                        }
                    </div>
                    <div className="col-12 my-2">
                    <Form.Item<mdlGiataRequest> name="userName">
                        <Input prefix={<>{t("common.userName")}</>}  />
                    </Form.Item>
                    </div>
                    <div className="col-12 mb-2">
                    <Form.Item<mdlGiataRequest> name="userTitle">
                        <Input prefix={<>{t("common.userTitle")}</>}  />
                    </Form.Item>
                    </div>
                    {
                        props.printMode != undefined && props.printMode &&
                        <>
                            <div className="col-12 mb-2">
                                <Form.Item<mdlGiataRequest> name="ipAddress">
                                    <Input prefix={<>{t("common.ipAddress")}</>}  />
                                </Form.Item>
                            </div>
                            <div className="col-12 mb-2">
                                <Form.Item<mdlGiataRequest> name="date">
                                    <Input prefix={<>{t("common.date")}</>}  />
                                </Form.Item>
                            </div>
                        </>
                    }
                    {
                    props.printMode == undefined || props.printMode == false &&
                    <>
                        <div className="col-12 mb-2">
                            {/*<Button className="btn btn-dark me-2" onClick={() => handlePrint()}>{t("factSheet.sendToGiata")}</Button>*/}
                            <Button className="btn btn-dark me-2" onClick={() => props.fnModalClose != undefined && props.fnModalClose()}>{t("common.print")}</Button>
                        </div>
                    </>
                    }
                </div>
            </Form>
        </>
    )
})